import { render } from "./Privileges.vue?vue&type=template&id=b164fd1c"
import script from "./Privileges.vue?vue&type=script&lang=js"
export * from "./Privileges.vue?vue&type=script&lang=js"

import "./Privileges.vue?vue&type=style&index=0&id=b164fd1c&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__